import React from 'react';
import PropTypes from 'prop-types';

import RadioGroup from './index';

const PicklistRadioGroup = ({
  onChange,
  value,
  ...rest
}) => {
  return (
    <RadioGroup
      onChange={(v) => {
        return onChange(v);
      }}
      value={value}
      {...rest}
    />
  );
};

PicklistRadioGroup.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string.isRequired,
};

export default PicklistRadioGroup;
